<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body width="80%">
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                                <el-form-item label="经销商">
                                    <el-select v-model="formInline.soldToCode"  remote filterable :filter-method="queryUser" clearable placeholder="请输入"
                                               :remote-method="queryUser" @change="getDingd" style="width: 90%">
                                        <el-option v-for="(item) in agentList"
                                                   :key="item.usercode"
                                                   :label="item.username"
                                                   :value="item.usercode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
								:border="true"
                                :data="ttdata"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    :selectable="checkSelectable"
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="销售订单号"
                                    width="150" >
                            </el-table-column>

                            <el-table-column
                                    prop="materialCode"
                                    label="物料号"
                                    width="120"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="materialName"
                                    label="物料描述"
                                    width="190"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="saleGroupCode"
                                    label="销售组织"
                                    width="150"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="factory"
                                    label="产地"
                                    width="120"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="proNumber"
                                    label="数量"
                                    width="90"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="finalPrice"
                                    label="单价"
                                    width="120"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="totalprice"
                                    label="总价"
                                    width="120"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <el-button type="primary"  @click="choseSelected">选择</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              formInline:{
                  sapCodeLike:null,
                  soldToCode:null,
              },
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  wlcodename:null,
                  usercode:null,
                  ddlx:null,
                  xmcode:null,
                  currencyCode:null,
                  customerChannelCode:null,
                  //预测号
                  yccode:null,
                  //预测国家
                  yccountry:null,
                  //预测人
                  ycrcode:'my',
                  country:null,

              },
              ttdata:null,
              lists:[],
              dailishangFlag: true,
              userRole: '',
              agentList:[],
          }
        },
        filters: {
            shifouchao60: function (value) {
                if(value == 3){
                    return "是"
                }
                return "否"
            }
        },
        methods: {
          checkSelectable(row) {

              return true

          },
            handleSelectionChange(lists){
                if(this.oneflag){
                    this.$emit('choseObj', lists[0])
                }else{
                    this.lists = lists;
                }
            },
            choseSelected(){
                if(this.lists.length === 0){
                  this.$message.warning('请至少选择一条数据.')
                  return
                }
                this.$emit('choseObj', this.lists)
            },
            //选择经销商
            queryUser(v){
                var q = {
                    ddlx:'2',
                    usercodename:null,
                }
                q.usercodename = v;
                ss.selectUserAgent.selectUserAgentList(q).then(rd=>{
                    this.agentList = rd;
                })
            },
            //根据选择的经销商获取订单
            getDingd(){
              console.log(this.formInline.sapCodeLike)
              ss.declaration.selectDingdList(this.formInline).then(rd=>{
                  if(rd.f){
                      this.ttdata = rd.msg;
                  }
              })
            },
        },
        created(){
            this.formInline.sapCodeLike = this.sapCode;
            this.formInline.soldToCode = this.agentCode;
            console.log(this.formInline)
            this.queryUser();
            this.getDingd();
        },
        computed: {
            //订单类型
            sapCode:function () {
                return this.sapCodeLike
            },
            agentCode:function () {
                return this.usercode
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            //订单类型
            sapCodeLike:{
                type:String,
            },
            //经销商编码
            usercode:{
                type:String,
            },
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
